import { GroupUrl } from '@icons';
import { Image } from '@ds';
import { getEmptyStateLabel } from '../utils';
import { Hub } from '@/api/apis/facilities';
import { ResourceFilters } from '../config';

type EmptyStatePlaceholderProps = {
  filters: ResourceFilters;
  selectedHub?: Hub;
};

export const EmptyStatePlaceholder = ({ filters, selectedHub }: EmptyStatePlaceholderProps) => {
  return (
    <div className="flex flex-col">
      <div className="bg-base-70 p-3 rounded-lg text-s-sb text-base-20 uppercase">Resources</div>
      <div className="flex items-center justify-center h-[407px]">
        <div className="flex flex-col items-center">
          <Image src={GroupUrl} height={180} />
          <div className="text-base-35 text-l-m">{getEmptyStateLabel(filters, !!selectedHub)}</div>
        </div>
      </div>
    </div>
  );
};
